$(document).ready(function () {
  $("#MediaGallery-template--22549599551805__main .product__media").append(
    $(
/*      '<img src="https://www.bausele.com/cdn/shop/files/Gold_Medal.png?v=1714443633">' 
      */
    )
  );
});
